import React, { useEffect, useState } from "react";
import LoadingOverlay from "./LoadingOverlay";
import { observeAuthFlowState } from "../services/userAuthService";

export default function AppChrome({ children }) {
  const [authFlowState, setAuthFlowState] = useState({
    active: false,
    title: "Loading",
    message: "Please wait a moment.",
  });

  useEffect(() => observeAuthFlowState(setAuthFlowState), []);

  return (
    <>
      {children}
      <LoadingOverlay
        active={authFlowState.active}
        title={authFlowState.title}
        message={authFlowState.message}
      />
    </>
  );
}
